import React, { useContext } from "react";
import { useEventContext } from "../../context/EventProvider";
import useEventDetails from "../../hooks/useEventDetails";
import { Recap } from '../wrap/wrapComponents';
import { ArticleBar } from "./aboutStyles";
const Articles = () => {
  const { event: { description, virtualDescription, lastRecapVideoHeader, lastRecapVideoId, lastRecapVideoProvider } } = useEventContext();
  const { virtual } = useEventDetails();
  return (
    <ArticleBar id="about">
      <h2>About</h2>
        <p>{/*virtual ? virtualDescription : description*/}
        The role of AI in responding to security threats has taken on new urgency as agency leaders grapple with AI's emergence into mainstream business applications. However, threat actors are moving just as quickly to capitalize on AI to advance their attacks.
<br /><br />
Secure your spot at the Google Public Sector Summit on Wednesday, October 16 to hear how agency and industry experts are approaching the widening intersection of AI and security. You'll hear from top leaders about where they're concentrating their AI efforts and gain important perspectives on how AI is being put to work in the public sector.
<br /><br />
Registration is complimentary for all attendees to this event.
        </p>
        <div className="lastWrap">
          <Recap recapVideoHeader={lastRecapVideoHeader} recapVideoId={lastRecapVideoId} recapVideoProvider={lastRecapVideoProvider} />
        </div>
      
      
    </ArticleBar>
  );
};

export default Articles;
